import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Home from './pages/Home/Home';
import Assessment from './pages/Assessment/Assessment'; // Will create next
import './styles/global.scss';

function App() {
  return (
    <Router>
      <div className="app">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/:assessmentTypeId/:gradeId" element={<Home />} />
          <Route path="/:assessmentTypeId/:gradeId/:scheduleId" element={<Home />} />
          <Route path="/:assessmentTypeId/:gradeId/:scheduleId/:branchId" element={<Home />} />
          <Route path="/assessment/:assessmentTypeId/:gradeId" element={<Assessment />} />
          <Route path="/assessment/:assessmentTypeId/:gradeId/:scheduleId" element={<Assessment />} />
          <Route path="/assessment/:assessmentTypeId/:gradeId/:scheduleId/:branchId" element={<Assessment />} />
          <Route path="/assessment/:gradeId" element={<Assessment />} />
        </Routes>
        <ToastContainer position="bottom-right" theme="colored" />
      </div>
    </Router>
  );
}

export default App;
